@if (mode() === 'view') {
    <div class="o-grid">
        <div class="o-grid__row">
            <div class="o-grid__item">
                <div class="c-info__block">
                    <h5>Hotel Brand Preference</h5>
                    <span id="hotelBrandPreference">{{
                        formGroup().controls.hotelBrandPreference.value || 'Unspecified'
                    }}</span>
                </div>
            </div>
            <div class="o-grid__item">
                <div class="c-info__block">
                    <h5>Special Needs</h5>
                    <span id="specialNeeds">{{ formGroup().controls.specialNeeds.value || 'Unspecified' }}</span>
                </div>
            </div>
        </div>
        <div class="o-grid__row">
            <div class="o-grid__item">
                <div class="c-info__block">
                    <h5>Hotel Room Preference</h5>
                    <span id="roomPreference">{{ formGroup().controls.roomPreference.value || 'Unspecified' }}</span>
                </div>
            </div>
            <div class="o-grid__item">
                <div class="c-info__block">
                    <h5>Allergies</h5>
                    <span id="allergies">{{ formGroup().controls.allergies.value || 'Unspecified' }}</span>
                </div>
            </div>
        </div>
    </div>
} @else if (mode() === 'edit') {
    <div class="grid grid-cols-2 gap-medpace-field">
        <mds-text-field
            id="hotelBrandPreference"
            [formCtrl]="formGroup().controls.hotelBrandPreference"
            [placeholder]="'Type here...'"
            [appearance]="'outline'"
            [inputType]="'text'"
            [label]="'Hotel Brand Preference'"
        />
        <mds-text-field
            id="specialNeeds"
            [formCtrl]="formGroup().controls.specialNeeds"
            [placeholder]="'Type here...'"
            [appearance]="'outline'"
            [inputType]="'text'"
            [label]="'Special Needs'"
        />
        <mds-text-field
            id="roomPreference"
            [formCtrl]="formGroup().controls.roomPreference"
            [placeholder]="'Type here...'"
            [appearance]="'outline'"
            [inputType]="'text'"
            [label]="'Hotel Room Preference'"
        />
        <mds-text-field
            id="allergies"
            [formCtrl]="formGroup().controls.allergies"
            [placeholder]="'Type here...'"
            [appearance]="'outline'"
            [inputType]="'text'"
            [label]="'Allergies'"
        />
    </div>
}
